module.exports = __webpack_public_path__ + "static/media/pothan-prof.27679a25.svg";